/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Estimated_Cost_ShortInputs */

const en_estimated_cost_short = /** @type {(inputs: Estimated_Cost_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est. Cost`)
};

const fr_estimated_cost_short = /** @type {(inputs: Estimated_Cost_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coût estimé`)
};

const de_estimated_cost_short = /** @type {(inputs: Estimated_Cost_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzte Kosten`)
};

const it_estimated_cost_short = /** @type {(inputs: Estimated_Cost_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo stimato`)
};

const ru_estimated_cost_short = /** @type {(inputs: Estimated_Cost_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ориентировочная стоимость`)
};

const es_estimated_cost_short = /** @type {(inputs: Estimated_Cost_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo estimado`)
};

const zh_cn2_estimated_cost_short = /** @type {(inputs: Estimated_Cost_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预计成本`)
};

const ja_estimated_cost_short = /** @type {(inputs: Estimated_Cost_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推定費用`)
};

const hi_estimated_cost_short = /** @type {(inputs: Estimated_Cost_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमानित लागत`)
};

const pt_pt2_estimated_cost_short = /** @type {(inputs: Estimated_Cost_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custo estimado`)
};

/**
* | output |
* | --- |
* | "Est. Cost" |
*
* @param {Estimated_Cost_ShortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const estimated_cost_short = /** @type {((inputs?: Estimated_Cost_ShortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Estimated_Cost_ShortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_estimated_cost_short(inputs)
	if (locale === "de") return de_estimated_cost_short(inputs)
	if (locale === "it") return it_estimated_cost_short(inputs)
	if (locale === "ru") return ru_estimated_cost_short(inputs)
	if (locale === "es") return es_estimated_cost_short(inputs)
	if (locale === "zh-CN") return zh_cn2_estimated_cost_short(inputs)
	if (locale === "ja") return ja_estimated_cost_short(inputs)
	if (locale === "hi") return hi_estimated_cost_short(inputs)
	if (locale === "pt-PT") return pt_pt2_estimated_cost_short(inputs)
	return en_estimated_cost_short(inputs)
});